import truckEditComponent from './truck.edit.component';

let truckEditModule = angular.module('truckedit', [
])

.component('truckedit', truckEditComponent)

.name;

export default truckEditModule;


// WEBPACK FOOTER //
// ./client/app/components/truck/edit/index.js